import React, { useEffect, useState } from "react";
import { apiRequest } from "../api";

const DeployFormTemplateModal = ({ formTemplate, onClose, onDeploy }) => {
    const [universities, setUniversities] = useState([]);
    const [selected, setSelected] = useState([]);
    const [loading, setLoading] = useState(true);
    const [deploying, setDeploying] = useState(false);
    const [error, setError] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);
    const [existingInstances, setExistingInstances] = useState([]);
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const token = localStorage.getItem("token");

    useEffect(() => {
        fetchUniversities();
        fetchExistingInstances();
    }, []);

    const fetchUniversities = async () => {
        setLoading(true);
        setError(null);
        try {
            const data = await apiRequest(`${apiUrl}/multi-user-universities`, "GET", null, token);
            setUniversities(data);
        } catch (err) {
            setError("Failed to load universities.");
        } finally {
            setLoading(false);
        }
    };

    const fetchExistingInstances = async () => {
        try {
            const data = await apiRequest(`${apiUrl}/form-templates/${formTemplate.id}/existing-instances`, "GET", null, token);
            setExistingInstances(data.existing_university_ids || []);
        } catch (err) {
            console.error("Failed to fetch existing instances:", err);
            setExistingInstances([]);
        }
    };

    const handleToggle = (id) => {
        setSelected((prev) =>
            prev.includes(id) ? prev.filter((uid) => uid !== id) : [...prev, id]
        );
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (selected.length === 0) {
            setError("Please select at least one university.");
            return;
        }
        setDeploying(true);
        setError(null);
        setSuccessMessage(null);
        try {
            const result = await apiRequest(
                `${apiUrl}/form-templates/${formTemplate.id}/deploy`,
                "POST",
                { university_ids: selected },
                token
            );
            
            // Show deployment results in modal
            let message = result.message;
            if (result.skipped_universities && result.skipped_universities.length > 0) {
                message += "\n\nSkipped universities:\n" + result.skipped_universities.map(s => s.reason).join("\n");
            }
            setSuccessMessage(message);
            
            // Auto-close after 3 seconds
            setTimeout(() => {
                onDeploy();
                onClose();
            }, 3000);
        } catch (err) {
            setError("Failed to deploy form template.");
        } finally {
            setDeploying(false);
        }
    };

    const isUniversityDisabled = (universityId) => {
        return existingInstances.includes(universityId);
    };

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
            }}
        >
            <div
                style={{
                    backgroundColor: "#fff",
                    padding: "20px",
                    borderRadius: "5px",
                    width: "500px",
                    maxHeight: "90vh",
                    overflowY: "auto",
                }}
            >
                <h4>Deploy Form Template</h4>
                {loading ? (
                    <div>Loading universities...</div>
                ) : error ? (
                    <div className="error">{error}</div>
                ) : (
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label>Select Universities</label>
                            <div style={{ maxHeight: 200, overflowY: "auto", border: "1px solid #eee", padding: 8 }}>
                                {universities.length > 0 ? (
                                    universities.map((uni) => {
                                        const isDisabled = isUniversityDisabled(uni.id);
                                        return (
                                            <div key={uni.id}>
                                                <label style={{ 
                                                    display: "flex", 
                                                    alignItems: "center", 
                                                    cursor: isDisabled ? "not-allowed" : "pointer",
                                                    opacity: isDisabled ? 0.6 : 1
                                                }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={selected.includes(uni.id)}
                                                        onChange={() => handleToggle(uni.id)}
                                                        disabled={deploying || isDisabled}
                                                        style={{ marginRight: "8px" }}
                                                    />
                                                    {uni.name}
                                                    {isDisabled && (
                                                        <span style={{ marginLeft: "8px", color: "#666", fontSize: "12px" }}>
                                                            (Already deployed)
                                                        </span>
                                                    )}
                                                </label>
                                            </div>
                                        );
                                    })
                                ) : (
                                    <div>No universities found.</div>
                                )}
                            </div>
                        </div>
                        {error && <div className="error">{error}</div>}
                        {successMessage && (
                            <div
                                style={{
                                    marginTop: "10px",
                                    padding: "10px",
                                    backgroundColor: "#d4edda",
                                    border: "1px solid #c3e6cb",
                                    borderRadius: "4px",
                                    color: "#155724",
                                    whiteSpace: "pre-line"
                                }}
                            >
                                {successMessage}
                            </div>
                        )}
                        <div className="modal-footer">
                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={deploying}
                            >
                                {deploying ? "Deploying..." : "Deploy"}
                            </button>
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={onClose}
                                disabled={deploying}
                            >
                                Cancel
                            </button>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
};

export default DeployFormTemplateModal; 